import makeStyles from "@mui/styles/makeStyles";

export const useDividerStyles = makeStyles({
  root: {
    height: 2,
  },
});
